import { Field, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
export class HaulerLogo {
  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  default?: string
}
